import * as React from "react";
import type { SVGProps } from "react";
const SvgIcPriority = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g clipPath="url(#ic_priority_svg__a)">
      <path
        fill="#EA2E2E"
        fillRule="evenodd"
        d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.73-6.227.163-5.046H7.107l.163 5.046zm-1.385 2.06q.273.27.653.27a.86.86 0 0 0 .455-.124 1 1 0 0 0 .337-.334.86.86 0 0 0 .132-.465.85.85 0 0 0-.281-.643.9.9 0 0 0-.643-.27.9.9 0 0 0-.653.27.87.87 0 0 0-.27.643q0 .383.27.653"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="ic_priority_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgIcPriority;
